import { useAuth0 } from '@auth0/auth0-react';
import LoaderFull from 'components/LoaderFull';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { requestAuth0 } from './api';
import { is } from 'uuidv4';

const Authorization = forwardRef(({ children }, ref) => {
  const location = useLocation();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const {
    getAccessTokenSilently,
    isLoading,
    isAuthenticated,
    user,
    getAccessTokenWithPopup,
  } = useAuth0();

  const getToken = async () => {
    try {
      const token = await getAccessTokenSilently(requestAuth0);
      return token ?? '';
    } catch (e) {
      if (history.location.pathname !== '/login') {
        const token = await getAccessTokenWithPopup(requestAuth0);
        return token ?? '';
      }
      return '';
    }
  };

  const updateToken = async () => {
    const token = await getToken();
    sessionStorage.setItem('structured:api-token', token);
    sessionStorage.setItem('structured:api-user', JSON.stringify(user));
    return { token, user };
  };

  useImperativeHandle(ref, () => ({
    handleUpdateToken() {
      return updateToken();
    },
  }));


  const redirectToLogin = () => {
    history.push({
      pathname: '/login',
      params: {
        search: `returnTo=${location.pathname}`,
      },
    });
  };

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated && history.location.pathname !== '/login') {
      (async () => {
        try {
          await updateToken();
        } catch (error) {
          setLoading(false);
        }
      })();
    } else {
      redirectToLogin();
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <LoaderFull />;
  }

  return <>{children}</>;
});

export default Authorization;
